import { Vector2 } from 'three';

// const SIZE = 1024;
// const canvas = document.createElement('canvas');
// canvas.width = canvas.height = SIZE;
// const ctx = canvas.getContext('2d');

class Face {
  constructor(id, attribute) {
    this.attribute = attribute;
    this.id = id;

    this.update();
  }

  update() {
    this.a = new Vector2(this.attribute.array[this.id], this.attribute.array[this.id + 1]);
    this.b = new Vector2(this.attribute.array[this.id + 2], this.attribute.array[this.id + 3]);
    this.c = new Vector2(this.attribute.array[this.id + 4], this.attribute.array[this.id + 5]);
    this.d = new Vector2(this.attribute.array[this.id + 8], this.attribute.array[this.id + 9]);

    this.left = this.a;
    this.right = this.c;

    if (this.b.x + this.b.y < this.left.x + this.left.y) this.left = this.b;
    if (this.c.x + this.c.y < this.left.x + this.left.y) this.left = this.c;
    if (this.d.x + this.d.y < this.left.x + this.left.y) this.left = this.d;

    if (this.a.x + this.a.y > this.right.x + this.right.y) this.right = this.a;
    if (this.b.x + this.b.y > this.right.x + this.right.y) this.right = this.b;
    if (this.d.x + this.d.y > this.right.x + this.right.y) this.right = this.d;

    this.w = this.right.x - this.left.x;
    this.h = this.right.y - this.left.y;
  }

  scale(scale) {
    for (let i = 0; i < 12; i += 2) {
      this.attribute.array[this.id + i] = this.left.x + this.attribute.array[this.id + i] * scale;
      this.attribute.array[this.id + i + 1] =
        this.left.y + this.attribute.array[this.id + i + 1] * scale;
    }

    this.update();
  }

  translate(x, y) {
    for (let i = 0; i < 12; i += 2) {
      this.attribute.array[this.id + i] = x - this.left.x + this.attribute.array[this.id + i];
      this.attribute.array[this.id + i + 1] =
        y - this.left.y + this.attribute.array[this.id + i + 1];
    }

    this.update();
  }

  /*
  debug(color) {
    ctx.globalAlpha = 0.3;
    ctx.fillStyle = color;
    ctx.strokeStyle = color;
    ctx.beginPath();
    ctx.moveTo(this.a.x * SIZE, this.a.y * SIZE);
    ctx.lineTo(this.b.x * SIZE, this.b.y * SIZE);
    ctx.lineTo(this.c.x * SIZE, this.c.y * SIZE);
    ctx.lineTo(this.d.x * SIZE, this.d.y * SIZE);
    ctx.lineTo(this.a.x * SIZE, this.a.y * SIZE);
    ctx.fill();
    ctx.stroke();
    ctx.globalAlpha = 1;
    ctx.fillStyle = '#0000ff';
    ctx.fillRect(this.left.x * size, this.left.y * size, 1, 1);
    ctx.fillStyle = '#ff0000';
    ctx.fillRect(this.right.x * size, this.right.y * size, 1, 1);
  }
  */
}

const correctUvUnwrap = (object) => {
  const attributes = [];
  const faces = [];
  object.traverse((mesh) => {
    if (!mesh.isMesh) return;
    const uv = mesh.geometry.getAttribute('uv2');
    attributes.push(uv);

    for (let i = 0; i < uv.count * 2; i += 12) {
      const face = new Face(i, uv);

      faces.push(face);
      // face.debug('#00ff00');
    }
  });

  faces.sort((a, b) => b.h - a.h);
  let offsetX = 0,
    offsetY = 0,
    maxY = 0;

  const mapPx = 3 / 1024;

  faces.forEach((face) => {
    if (offsetX + face.w > 1) {
      offsetX = 0;
      offsetY += maxY + mapPx;
      maxY = 0;
    }
    face.scale(2);
    face.translate(offsetX, offsetY);
    offsetX += face.w + mapPx;

    maxY = Math.max(face.h, maxY);
    // face.debug('#ff0000');
  });

  attributes.forEach((a) => {
    a.needsUpdate = true;
  });
};

export default correctUvUnwrap;
